import {
  Table,
  AddRowButton,
  RemoveRowButton,
  Form,
  Input,
  InputNumber,
  Radio,
  DatePickerProps,
} from "formik-antd";
import _ from "lodash";
import { Formik } from "formik";
import {
  Button,
  Space,
  DatePicker,
  Row,
  Col,
  Alert,
  message,
  notification,
} from "antd";
import React, { useContext, useEffect, useState } from "react";
import MultiStepFormContext from "./MultiStepFormContext";
// import { DatePicker, DatePickerProps } from "antd";
// import "antd/dist/antd.css"
import { DeleteOutlined } from "@ant-design/icons";
import moment from "moment";
import dayjs from "dayjs";
import axios from "axios";
import { Backdrop, CircularProgress } from "@mui/material";

export default function References() {
  const { references, setReferences, next } = useContext(MultiStepFormContext);
  useEffect(() => {}, []);
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("Data Saved Successfully!!");
  function onFinish(values) {
    next();
  }
  const handleClose = () => {
    setAlertVisible(false);
  };
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flex: 1,
        justifyContent: "center",
      }}
    >
      <Formik
        initialValues={references}
        onSubmit={(values) => {
          setLoading(true);
          setReferences(values);
          if (values.references.length <= 3) {
            message.error("Atleast 3 refrences is required");
            setLoading(false);
            return false;
          }
          var url = window.API_PREFIX + "forms/api/post/references";
          const requestOptions = {
            data: values,
            applicationId: sessionStorage.getItem("applicationId"),
            user: sessionStorage.getItem("username"),
            token: sessionStorage.getItem("token"),
          };
          axios
            .post(url, requestOptions)
            .then((res) => {
              if (res.data.status == 200) {
                setAlertType("success");
                setAlertMessage(res.data.info);
                setAlertVisible(true);
              } else if (res.data.status == 409) {
                setAlertType("info");
                setAlertMessage(res.data.info);
                setAlertVisible(true);
              }
              onFinish();
            })
            .catch((err) => {
              console.log(err);
              message.error(
                "Please fill the correct information. Try again after refreshing the page",
                10
              );
            })
            .finally(() => {
              setLoading(false);
            });
        }}
        validateOnChange={true}
        validateOnBlur={true}
        validate={(values) => {
          var errors = [];
          var ref1 = [];
          var ref = values["references"];

          for (var i = 0; i < ref.length; i++) {
            let error = {};

            Object.keys(ref[i]).map((key) => {
              if (
                (ref[i][key] === "" ||
                  ref[i][key] === null ||
                  ref[i][key] == dayjs()) &&
                key !== "officePhone"
              ) {
                error[key] = _.capitalize(_.startCase(key) + "is required");
              }

              if (key === "mobilePhone" && ref[i][key]) {
                const phonePattern = /^[0-9]{10}$/;
                if (!phonePattern.test(ref[i][key])) {
                  error[key] = "Invalid Mobile Phone Number";
                }
              }

              if (key === "officePhone" && ref[i][key]) {
                const phonePattern = /^[0-9]{10}$/;
                if (!phonePattern.test(ref[i][key])) {
                  error[key] = "Invalid Office Phone Number";
                }
              }

              if (key === "email" && ref[i][key]) {
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailPattern.test(ref[i][key])) {
                  error[key] = "Invalid Email Address";
                }
              }

              if (
                ["name", "address", "occupation"].includes(key) &&
                ref[i][key]
              ) {
                if (ref[i][key].trim() === "") {
                  error[key] = key + " cannot be empty or just spaces";
                }
              }

              if (["name", "address"].includes(key) && ref[i][key]) {
                if (ref[i][key].length > 100) {
                  error[key] = key + " cannot exceed 100 characters";
                }
              }

              if (["name", "occupation"].includes(key) && ref[i][key]) {
                const specialCharPattern = /[^a-zA-Z0-9 ]/;
                if (specialCharPattern.test(ref[i][key])) {
                  error[key] = key + " cannot contain special characters";
                }
              }
            });

            if (Object.keys(error).length == 0) {
              ref1.push(null);
            } else {
              ref1.push(error);
            }
          }
          errors = ref1;
          if (
            errors.every((item) => {
              return item == null;
            })
          ) {
            return [];
          }
          return errors;
        }}
      >
        {({ handleSubmit, values, setFieldValue, touched, errors }) => (
          <Form>
            <Table
              name="references"
              rowKey={(row, index) => "" + index}
              size="small"
              pagination={false}
              style={{ width: "100%" }}
              columns={[
                {
                  title: (
                    <>
                      Name
                      <span style={{ color: "red" }}>*</span>
                    </>
                  ),
                  key: "name",
                  render: (text, record, i) => (
                    <>
                      <Input
                        // style={{ border: "none" }}
                        name={`references.${i}.name`}
                        placeholder="Enter name"
                      />
                      {errors[i] &&
                      "name" in errors[i] &&
                      touched &&
                      "references" in touched &&
                      touched["references"][i] &&
                      "name" in touched["references"][i] &&
                      touched["references"][i]["name"] ? (
                        <div style={{ color: "red" }}>{errors[i]["name"]}</div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: (
                    <>
                      Address
                      <span style={{ color: "red" }}>*</span>
                    </>
                  ),
                  key: "address",
                  render: (text, record, i) => (
                    <>
                      <Input
                        name={`references.${i}.address`}
                        placeholder="e.g. Ahmedabad, Gujarat"
                      />
                      {errors[i] &&
                      "address" in errors[i] &&
                      touched &&
                      "references" in touched &&
                      touched["references"][i] &&
                      "address" in touched["references"][i] &&
                      touched["references"][i]["address"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["address"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: (
                    <>
                      Occupation
                      <span style={{ color: "red" }}>*</span>
                    </>
                  ),
                  key: "occupation",
                  render: (text, record, i) => (
                    <>
                      <Input
                        name={`references.${i}.occupation`}
                        placeholder="e.g. Manager, Professor"
                      />
                      {errors[i] &&
                      "occupation" in errors[i] &&
                      touched &&
                      "references" in touched &&
                      touched["references"][i] &&
                      "occupation" in touched["references"][i] &&
                      touched["references"][i]["occupation"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["occupation"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },

                {
                  title: (
                    <>
                      Mobile Phone Number
                      <span style={{ color: "red" }}>*</span>
                    </>
                  ),
                  key: "mobilePhone",
                  render: (text, record, i) => (
                    <>
                      <Input
                        // style={{ border: "none" }}
                        name={`references.${i}.mobilePhone`}
                        placeholder="Enter Mobile Phone"
                        type="number"
                      />
                      {errors[i] &&
                      "mobilePhone" in errors[i] &&
                      touched &&
                      "references" in touched &&
                      touched["references"][i] &&
                      "mobilePhone" in touched["references"][i] &&
                      touched["references"][i]["mobilePhone"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["mobilePhone"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: "Office Phone Number",
                  key: "officePhone",
                  render: (text, record, i) => (
                    <>
                      <Input
                        // style={{ border: "none" }}
                        name={`references.${i}.officePhone`}
                        placeholder="Enter office phone number"
                        type="number"
                        min={0}
                      />
                      {errors[i] &&
                      "officePhone" in errors[i] &&
                      touched &&
                      "references" in touched &&
                      touched["references"][i] &&
                      "officePhone" in touched["references"][i] &&
                      touched["references"][i]["officePhone"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["officePhone"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: (
                    <>
                      Email ID
                      <span style={{ color: "red" }}>*</span>
                    </>
                  ),
                  key: "email",
                  render: (text, record, i) => (
                    <>
                      <Input
                        // style={{ border: "none" }}
                        name={`references.${i}.email`}
                        placeholder="Email"
                      />
                      {errors[i] &&
                      "email" in errors[i] &&
                      touched &&
                      "references" in touched &&
                      touched["references"][i] &&
                      "email" in touched["references"][i] &&
                      touched["references"][i]["email"] ? (
                        <div style={{ color: "red" }}>{errors[i]["email"]}</div>
                      ) : null}
                    </>
                  ),
                },

                {
                  key: "actions",
                  render: (text, record, index) => (
                    <RemoveRowButton
                      style={{ border: "none" }}
                      icon={<DeleteOutlined />}
                      name="references"
                      index={index}
                    />
                  ),
                },
              ]}
            />
            <Row gutter={10} style={{ margin: "50px" }}>
              <AddRowButton
                name="references"
                style={{ marginBottom: 12 }}
                createNewRow={() => ({
                  name: "",
                  address: "",
                  occupation: "",
                  mobilePhone: "",
                  officePhone: "",
                  email: "",
                })}
              >
                Add Reference (if any)
              </AddRowButton>
            </Row>
            <Row gutter={10} style={{ margin: "50px" }}>
              <Space direction="vertical" style={{ width: "100%" }}>
                {alertVisible && (
                  <Alert
                    message={alertMessage}
                    type={alertType}
                    closable
                    afterClose={handleClose}
                  />
                )}
                {alertVisible}
              </Space>
            </Row>
            <Row gutter={10} style={{ margin: "50px" }}>
              <Col>
                <Button type={"primary"} onClick={handleSubmit}>
                  Save
                </Button>
              </Col>
              {/* <Col>
                                <Button type={"success"} onClick={onFinish}>
                                    Next
                                </Button>
                            </Col> */}
            </Row>
          </Form>
        )}
      </Formik>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
